import React, { PureComponent } from 'react';
import {
  Col,
  Row,
  Grid,
} from 'react-bootstrap';
import './Footer.css';

class Footer extends PureComponent {
  render() {
    return (
      <div className="Footer">
        <Grid>
          <Row>
            <Col sm={12}>
              &copy; 2017 Susan Payne O'Brien
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx